module.exports = __webpack_public_path__ + "media/images/mobile-only/element02-dd1710e72091bb54047259cf5c6a0134.png";